import { TableCell } from "@mui/material";
import { styled } from "@mui/material/styles";

export const EmptyTableCell = styled(TableCell)({ padding: 0, width: 0 });
export default EmptyTableCell;
